import { Create } from '@fund/api-modules';
import { setUserInfoBeforeRequest } from '@fund/api-modules/dist/tools/setUserInfo';
import { getApiHost, env } from '@fund/api-host';
import InterceptOptionError from './decorator/optionDecorator';

@setUserInfoBeforeRequest((res) => {
  // 获取路由参数
  const currentHash = window.location.hash;
  const queryString = currentHash.slice(1);
  const params = new URLSearchParams(queryString);
  const json = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of params.entries()) {
    json[key] = value;
  }
  return {
    baseURL: getApiHost('optionapi', env),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    params: {
      userid: json.uid || '',
      passportid: json.passportid || '',
      passportctoken: json.passportctoken || '',
      passportutoken: json.passportutoken || '',
      ctoken: json.ctoken || '',
      utoken: json.utoken || '',
      deviceid: json.deviceid || '',
      version: json.v || res.serverversion || '',
      product: json.product || 'EFund',
      plat: json.plat || 'Iphone',
    },
    validmark: {
      uid: json.uid || '',
      deviceid: json.deviceid || '',
      passportid: json.passportid || '',
    },
  };
})
@Create()
class OptionApi {
  // 添加自选分组============================================
  @InterceptOptionError('新建分组')
  addOptionGroup(params) {
    return this.GET('/favor/group/create', params);
  }

  // 删除自选分组
  @InterceptOptionError('删除分组')
  deleteOptionGroup(params) {
    return this.POST('/favor/group/delete', params);
  }

  // 排序自选分组
  @InterceptOptionError('分组排序')
  sortOptionGroup(params) {
    return this.POST('/favor/group/setOrder', params);
  }

  // 编辑分组名称
  @InterceptOptionError('编辑分组名称')
  editOptionGroup(params) {
    return this.POST('/favor/group/update', params);
  }

  // 创建分组并加自选
  @InterceptOptionError('创建组合加自选')
  createGroupAddFunds(params) {
    return this.POST('/favor/groupCode/add', params);
  }

  // 删除自选持仓某条或多条数据
  @InterceptOptionError('删除自选持仓某条或多条数据')
  delHoldOptionFunds(params) {
    return this.POST('/favor/hold/del', params);
  }

  // 置顶自选持仓
  @InterceptOptionError('置顶自选持仓')
  sortHoldOptionFund(params) {
    return this.POST('/favor/hold/settop', params);
  }

  getOptionList() {
    return this.GET('/favor/fcode/getcodes');
  }

  // 基金加自选
  @InterceptOptionError('基金加自选')
  addOptionFund(params) {
    return this.GET('/favor/fcode/add', params);
  }

  // 基金删自选
  @InterceptOptionError('基金删自选')
  delOptionFund(params) {
    return this.GET('/favor/fcode/del', params);
  }

  // 获取分组列表
  @InterceptOptionError('获取分组列表')
  getGroupList() {
    return this.POST('/favor/group/get', {
      favorversion: -2000,
    });
  }

  // 置顶
  @InterceptOptionError('置顶')
  setTop(params) {
    return this.POST('/favor/top/setTopNew', params);
  }
}

const optionapi = new OptionApi();
export default optionapi;
